module.exports = __webpack_public_path__ + "static/img/40010 (2).6d8d36b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40010 (2).webp
// module id = 2rET
// module chunks = 14